import { Link } from 'react-router-dom';
import { SITE } from '@/mocks/site';

export default function CtaSection() {
  return (
    <section id="submit" className="relative w-full overflow-hidden scroll-mt-20">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=dim%20archive%20corridor%20with%20tall%20shelves%20of%20old%20boxes%20and%20film%20canisters%2C%20a%20warm%20amber%20light%20beam%20cutting%20through%20dusty%20air%2C%20mysterious%20cinematic%20atmosphere%2C%20deep%20brown%20and%20rust%20tones%2C%20editorial%20photography&width=1600&height=700&seq=hlkb-cta-01&orientation=landscape"
          alt="昏暗的档案走廊与高耸的旧资料架，一束暖光穿过空气中"
          title="提交线索 - 黑料百科档案室"
          className="w-full h-full object-cover object-center"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-background-50 via-background-50/90 to-background-50/60"></div>

      <div className="relative z-10 w-full px-4 md:px-8 py-16 md:py-24">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 text-[11px] tracking-[0.3em] text-primary-500">
            <span className="w-6 h-px bg-primary-500 inline-block"></span>
            TIPS WANTED
          </span>
          <h2 className="mt-4 font-heading text-2xl md:text-4xl text-foreground-950 leading-tight">
            你硬盘里那份旧存档，可能正是缺的那一块
          </h2>
          <p className="mt-5 text-sm md:text-base text-foreground-700 leading-relaxed">
            无论是十年前的截图、刻录光盘里的网页存档，还是只剩一句转述的记忆，都可以投递给我们。
            档案员会先做初步核对，如果入库，会回信告知对应的档案编号。
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <a
              href={`mailto:${SITE.submitEmail}`}
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-md bg-accent-500 text-background-50 text-sm font-medium hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-send-plane-line"></i>
              {SITE.submitEmail}
            </a>
            <Link
              to="/about"
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-md border border-background-400/70 text-foreground-900 text-sm hover:border-primary-500 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
            >
              了解档案原则
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}